import React, { useState, useEffect } from "react";
import Layout from "../Common/Layout";
import BillingDTR from "./BillingDTR.jsx";
import QualityOutbound from "./QualityOutbound.jsx";
import QualityWeekly from "./QualityWeekly.jsx";
import InvoiceTable from "./InvoiceTable.jsx";
import QcDateRangeReport from "./QualityWeekly.jsx";
import LabourRequirementReport from "./LabourRequirementReport.jsx";
import InvoiceDateRangeList from "./InvoiceDateRangeList.jsx";
import StockBalanceNetWtReport from "./StockBalanceNetWtReport.jsx";
import { useLocation } from "react-router-dom";

const ReportBilling = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.reportType) {
      setReportType(location.state.reportType);
    }
  }, [location.state]);

  const [reportType, setReportType] = useState("");
  return (
    <>
      <Layout>
        <div
          className="container d-flex justify-content-center align-items-center"
          style={{ minHeight: "10vh", width: "30rem" }}
        >
          <select
            className="form-select"
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
          >
            <option value="">-- Select Report --</option>
            <option value="dtr">Daily Transaction Reports (DTR)</option>
            <option value="weekly-quality">
              Weekly Quality & Condition Reports
            </option>
            <option value="monthly-summary">Monthly Summary Invoices</option>
            <option value="quarterly-audit">
              Quarterly Performance & Audit Reports
            </option>
            <option value="stock-balance">Stock Balance Report</option>
            <option value="space-report">Available Space Report</option>
            <option value="labour-report">Labour Requirement Report</option>
          </select>
        </div>

        {/* Render Selected Component */}
        {reportType === "dtr" && <InvoiceTable></InvoiceTable>}
        {reportType === "weekly-quality" && <QcDateRangeReport />}
        {reportType === "monthly-summary" && <InvoiceDateRangeList />}
        {/* {reportType === "quarterly-audit" && <QuarterlyAuditReport />} */}
        {reportType === "stock-balance" && <StockBalanceNetWtReport />}
        {/* {reportType === "space-report" && <AvailableSpaceReport />}  */}
        {reportType === "labour-report" && <LabourRequirementReport />}
      </Layout>
    </>
  );
};

export default ReportBilling;
